// @flow
import React, {PureComponent} from 'react';
import {Separator} from 'trpc-react-native-ui';
import {
  ConfirmationModal,
  GenericPostRequestModal,
  GradientPage,
} from '../../common';
import SelectSubscriptionPage from '../SelectSubscriptionPage';
import ValidationButton from '../ValidationButton';

import type {LoadingStatusStateType} from '../../../modules/LoadingStatus';
import type {Subscription} from 'digicel-kaizen-library';
import { SafeAreaView } from 'react-native-safe-area-context';

export default class PickLine extends PureComponent<Props> {
  styles = getStyles();

  renderPrimaryButton = ({style, ...props}: Object): any =>
    this.props.modalContent ? (
      <ConfirmationModal
        openModalText={this.props.confirmButtonText}
        confirmContent={this.props.modalContent(props.subscription)}
        onConfirm={props.onPress}
        {...props}
      />
    ) : (
      <ValidationButton
        loading={this.props.isLoading}
        onPress={props.onPress}
        text={this.props.confirmButtonText}
      />
    );

  render() {
    const {eSimSelected} = this.props;
    const WrapperView = this.props.withGradient ? GradientPage : SafeAreaView;
    return (
      <WrapperView style={this.styles.container} iosEdges={['top', 'bottom', 'left', 'right']} edges={['bottom', 'left', 'right']}>
        <SelectSubscriptionPage
          title={this.props.title}
          subscriptions={this.props.subscriptions}
          style={this.styles.selectSubscriptionContainer}
          PrimaryButton={this.renderPrimaryButton}
          onPressPrimaryButton={
            eSimSelected ? this.props.onConfirmForEsim : this.props.onConfirm
          }
        />
        <Separator />
        {this.props.modalContent && (
          <GenericPostRequestModal
            loadingSelector={this.props.loadingSelector}
          />
        )}
      </WrapperView>
    );
  }
}

const getStyles = () => ({
  container: {
    flex: 1,
  },
  selectSubscriptionContainer: {
    paddingTop: 16,
  },
});

type Props = StateProps & DispatchProps;

export type StateProps = {
  confirmButtonText: string,
  isLoading?: boolean,
  loadingSelector: $Keys<LoadingStatusStateType>,
  modalContent?: Subscription => string,
  subscriptions: Subscription[],
  title: string,
  withGradient?: boolean,
};

export type DispatchProps = {
  onConfirm?: (?Subscription) => any,
  onConfirmForEsim?: (?Subscription) => any,
};
